// TumHaberler.tsx
import React, { useEffect, useState } from "react";
import Layout from "../../components/yenimahalle/Layout";
import BasicHeader from "../../components/yenimahalle/BasicHeader";
import PortalApi from "api/PortalApi";
import ListGridOnlyYear from "components/yenimahalle/ListGridOnlyYear";
import { DecisionsItem } from "models/Response/Portal";

const MeclisKararlari: React.FC = () => {
  const [agendaList, setAgendaList] = useState<any[]>([]);
  const monthNames = [
    "Ocak",
    "Şubat",
    "Mart",
    "Nisan",
    "Mayıs",
    "Haziran",
    "Temmuz",
    "Ağustos",
    "Eylül",
    "Ekim",
    "Kasım",
    "Aralık",
  ];
  const fetchData = async (year: string) => {
    const response = await PortalApi.getMeclisKararlari(parseInt(year));
    if (response && response.meclisList) {
      const mappedItems = response.meclisList.map((item: DecisionsItem) => {
        const monthName = monthNames[item.month - 1];
        return {
          id: item.id,
          title: `${monthName} ${item.year}`,
          fileUrl: item.fileUrl,
        };
      });
      setAgendaList(mappedItems);
    }
  };

  const handleFilterChange = (year: string) => {
    fetchData(year);
  };

  useEffect(() => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear().toString();
    fetchData(currentYear);
  }, []);

  const handleCardClick = (item: DecisionsItem) => {
    window.open(item.fileUrl, "_blank", "noopener,noreferrer");
  };
  return (
    <Layout>
      <BasicHeader headingLine1="Sosyal Belediyecilik Anlayışına Sahip Mutlu Bir İlçe" headingLine2="" />
      <ListGridOnlyYear
        items={agendaList}
        showDateFilter={true}
        onFilterChange={handleFilterChange}
        onItemClick={handleCardClick}
      />
    </Layout>
  );
};

export default MeclisKararlari;
